export default "__VITE_ASSET__CmyIMOPM__"